import { render, staticRenderFns } from "./UnNotificationsCenter.vue?vue&type=template&id=48dbdeab&"
import script from "./UnNotificationsCenter.vue?vue&type=script&lang=js&"
export * from "./UnNotificationsCenter.vue?vue&type=script&lang=js&"
import style0 from "./UnNotificationsCenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBadge,VBtn,VDialog,VIcon})
